import React from 'react';
import { Typography, useTheme } from '@mui/material';
import { H, V } from '../Layout';
import { PUNCTUATION_MARKS_CONSTANTS } from '../constants/constants';
import I18n from '../i18n/I18n';
import { useStyling } from '../Theme';

interface FilterDisplayProps {
    groupedFilters: Record<string, string[]>;
    toLabel: (identifier: string) => string;
    description?: string;
}

const FilterDisplay: React.FC<FilterDisplayProps> = ({ groupedFilters, toLabel, description }) => {
    const { theme } = useStyling();

    if (Object.keys(groupedFilters).length === 0) {
        return (
            <Typography color="text.secondary" sx={{ fontWeight: theme.typography.body2 }}>
                <I18n token="common.all" />
            </Typography>
        );
    }

    return (
        <V gap={1}>
            {description && <Typography sx={{ fontWeight: theme.typography.body2 }}>{description}</Typography>}
            {Object.entries(groupedFilters).map(([identifier, values]) => (
                <H key={identifier} gap={1} sx={{ alignItems: 'flex-start' }}>
                    <Typography sx={{ minWidth: 'fit-content', fontWeight: theme.typography.body2 }}>
                        {toLabel(identifier)}:
                    </Typography>
                    <Typography sx={{ fontWeight: theme.typography.body2 }}>
                        {values.join(` ${PUNCTUATION_MARKS_CONSTANTS.pipe} `)}
                    </Typography>
                </H>
            ))}
        </V>
    );
};

export default FilterDisplay;
